import { render } from "./composite-items.vue?vue&type=template&id=33c035ae"
import script from "./composite-items.vue?vue&type=script&lang=js"
export * from "./composite-items.vue?vue&type=script&lang=js"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__